import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import blackWallet from '../Main/image/WalletB.png';
import { TextField } from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Dicon from '../Main/image/Icon256.png';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import LockImage from '../Main/image/lock.png';
import EthImage from '../Main/image/2089411.png';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";









function Walletinformation() {
    const { loginStore } = useStore();
    const { CoinStore } = useStore();

    // const navigate = useNavigate();

    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: '440px',
            height: "400px"
        },
        DialogMobile: {
            height: 'auto',
            width: '100%',
            minWidth: "320px",
        },
        //blackWallet
        blackWalletImage: {
            width: '108%',
            marginRight: '-265px'

        },
        blackWalletImageMobile: {
            width: '90%',
            marginRight: '-265px'
        },

    }));


    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");

    let Guide_clover_dialog_Walletinformation_01 = loginStore?.Guide_clover_dialog_Walletinformation_01; //My.지갑
    let Guide_clover_allPage_05 = loginStore?.Guide_clover_allPage_05; //보내기
    let ErrorGuide_clover_page_userBar_01 = loginStore?.ErrorGuide_clover_page_userBar_01; //복사에 실패하였습니다
    let Guide_clover_page_userBar_01 = loginStore?.Guide_clover_page_userBar_01; //복사 하였습니다





    const StandCount = CoinStore.GuideStandCoin;
    // const UserLockToken = CoinStore.UserLockToken.lockCount;
    const GuideEtherCoin = CoinStore.GuideEtherCoin;
    const Wallet = CoinStore.WalletData.address;
    const isWalletDialogOpen = loginStore.isWalletDialogOpen;

    let LockToken = CoinStore.UserCoinLockTokenValue;

    const copy = async (text) => {
        // console.log(text);
        if (text === undefined || text === null || text === "") {
            return alert(ErrorGuide_clover_page_userBar_01);
        }
        else {
            try {
                await navigator.clipboard.writeText(text);
                return alert(Guide_clover_page_userBar_01);
            } catch (error) {
                // console.log(error);
                return alert(ErrorGuide_clover_page_userBar_01);
            }
        }
    }





    const WhiteTextTypography = withStyles({
        root: {
            fontSize: "1.5rem",
            color: "#FFFFFF",
        }
    })(Typography);
    // inputProps={isMobile ? {min: 0, style: { textAlign: 'center',fontSize: 13 }} : {min: 0, style: { textAlign: 'center' }} } 
    const WalletTextField = ({ iconStart, iconEnd, InputProps, ...props }) => {
        return (
            <TextField
                fullWidth
                variant="standard"
                {...props}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 7.7 } } : { min: 0, style: { textAlign: 'center', fontSize: 14, } }}
                InputProps={{
                    ...InputProps,
                    startAdornment: iconStart ? (
                        <InputAdornment position="start">{iconStart}</InputAdornment>
                    ) : null,
                    endAdornment: iconEnd ? (
                        <InputAdornment position="end">{iconEnd}</InputAdornment>
                    ) : null,
                    fontSize: '10'
                }}
            />
        );
    };


    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isWalletDialogOpen} onClose={loginStore.setDialogClose}>
                <Box sx={{ display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600vw', height: '7vh', }}>
                    {/* <Container>
                        <img className={ isMobile ? classes.CloverleafImageMobile : classes.CloverleafImage } src={CloverleafImage} alt="Cloverleaf" /> 
                    </Container>
                    <Container className={ isMobile ? classes.TextWalletLocationMobile : classes.TextWalletLocation }>
                        <WhiteTextTypography variant={ isMobile ? "subtitle1" : "h5" }> My.지갑</WhiteTextTypography>
                    </Container>
                    <Container className={ isMobile ? classes.XLocationMobile : classes.XLocation }>
                    <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => {loginStore.setDialogClose("WalletFalse")}} />
                    </Container> */}
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography variant={isMobile ? "subtitle1" : "h5"}>{Guide_clover_dialog_Walletinformation_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("WalletFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <DialogContent >
                    <WalletTextField
                        disabled
                        value={Wallet !== undefined ? Wallet : ''}
                        iconStart={<img src={blackWallet} className={isMobile ? classes.blackWalletImageMobile : classes.blackWalletImage} alt='blackWallet' />}
                        iconEnd={<FontAwesomeIcon icon={faCopy} size={isMobile ? 'lg' : 'xl'} onClick={(e) => { copy(Wallet !== undefined ? Wallet : '') }} />}
                    />
                    <Box sx={{ border: 1, borderRadius: '10px', marginTop: '20px' }} >
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' justifyContent='center' alignItems='center' >
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' gap={0.5}>
                                    <img src={Dicon} style={{ width: '25px', height: "25px" }} alt='DiconImage' />
                                    <Typography variant={isMobile ? "subtitle1" : "h6"}>{StandCount !== undefined ? StandCount : '0'}</Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' gap={0.5}>
                                <img style={{ width: '25px', height: "25px" }} src={LockImage} alt='LockImage' />
                                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h6"}>{LockToken !== undefined ? LockToken : '0'}</Typography>
                                {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1} /> */}
                                <Button variant="contained" size="small"
                                    sx={isMobile ? { marginRight: "-33%",marginLeft: "10%" }
                                        :
                                        { marginRight: "-60px", width: "-10%" }
                                    }
                                    onClick={() => loginStore.setDialogOpen("CloverLock")}
                                >
                                    List</Button>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' gap={0.5}>
                                <img style={{ width: '25px', height: "25px" }} src={EthImage} alt='EthImage' />
                                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h6"}>{GuideEtherCoin !== undefined ? GuideEtherCoin : '0'}</Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' />
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' />
                        </Grid>
                    </Box>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-end' marginTop='25px'>
                        <Button variant="contained" size="medium"
                            style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { loginStore.setDialogOpen("CoinSend") }} >{Guide_clover_allPage_05}</Button>
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default observer(Walletinformation);